






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ProfileImage extends Vue {
  @Prop({ type: String, default: '' }) readonly customStyle?: string
  @Prop({ type: String, default: 'img/default-profile.png' }) readonly image?: string

  get imageSrc(): string {
    return this.image ? this.image : 'img/default-profile.png'
  }
}
